module.exports = __webpack_public_path__ + "static/media/leaf-oak.0b9a8922.svg";